import { queryParams } from "helpers/reqparams";
import { body, request } from "services/request";

const resource = "api/relays";

const getCars = (params: {}) => request(`${resource}/getCars${queryParams(params)}`, { method: "GET" });
const getSensors = () => request(`${resource}/getSensors`, { method: "GET" });
const getRelayTypes = () => request(`${resource}/getRelayTypes`, { method: "GET" });
const addCars = (params: {}) => request(`${resource}/addCars`, body(params));
const apply = (params: {}) => request(`${resource}/apply`, body(params));
const skipSelfRegistrationRelaySetup = () => request(`${resource}/skipSelfRegistrationRelaySetup`, body({}));
const closeRelayConnectionNeedAlert = () => request(`${resource}/closeRelayConnectionNeedAlert`, body({}));
const closeRelayConnectingModal = (data: {}) => request(`${resource}/closeRelayConnectingModal`, body(data));

export {
    apply,
    getCars,
    addCars,
    getSensors,
    getRelayTypes,
    skipSelfRegistrationRelaySetup,
    closeRelayConnectionNeedAlert,
    closeRelayConnectingModal,
};
